import { all, put, select, take } from 'redux-saga/effects';

import { RESET_NOTEBOOK } from './actions';
import { CLOSE_FILTER_PANEL, SAVE_FILTER_MARKER_COLORS, SAVE_SORT_ORDER } from 'Reducers/compModels';


function* resetNotebook() {
  while (true) {
    yield take(RESET_NOTEBOOK);
    let defaultDisplay = [];

    const { notebook:{ displayAnnotationColors }} = yield select(state => {
      return {
        notebook: state.notebook
      };
    });

    for (const displayAnnotationColor of displayAnnotationColors) {
      const { display, disabled } = displayAnnotationColor;

      if (!disabled) {
        defaultDisplay.push({
          ...displayAnnotationColor,
          display: true
        });
      } else {
        defaultDisplay.push(displayAnnotationColor)
      }
    }

    yield all([
      put({ type: SAVE_FILTER_MARKER_COLORS, data: defaultDisplay }),
      put({ type: SAVE_SORT_ORDER, data: 'Newest' }),
      put({ type: CLOSE_FILTER_PANEL })
    ]);
  }
}


export default resetNotebook;
